import moment from 'moment';

import calculateBalance from './calculateBalance';

const memo = new Map();

export default function calculateCushion({ row, sortedInvoices, bills }) {
  if (!sortedInvoices) {
    return '-';
  }

  if (row.sequence === 0) {
    return '-';
  }

  if (memo.has(row.id)) {
    return memo.get(row.id);
  }

  const futureDate = moment(row.date).add(11, 'month');
  const futureInvoice = sortedInvoices.find((inv) =>
    moment(inv.date).isSame(futureDate, 'day')
  );

  if (!futureInvoice) {
    return '-';
  }

  const balance = calculateBalance({
    row: futureInvoice,
    sortedInvoices,
    bills,
  });

  const divider =
    row.status === 'paid'
      ? row._paid_impounds?.amount_paid
      : row._impounds_total?.invoice_total;

  if (!divider) {
    return '-';
  }

  const value = (balance / divider).toFixed(1);

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(value)) {
    memo.set(row.id, '-');
    return '-';
  }
  memo.set(row.id, value);

  return value;
}

export function clearCushionMemo() {
  memo.clear();
}
